export class stageGeneratorParent {
  //根据传入的新对象来更新默认数据，做diff
  objDiff(oldObj, newObj) {
    if (typeof newObj !== "object") return
    for (const key in newObj) {
      const element = newObj[key]
      if (typeof element === "object" && Object.prototype.hasOwnProperty.call(oldObj, key)) {
        this.objDiff(oldObj[key], element)
      } else {
        oldObj[key] = element
      }
    }
  }
}
